import ModalHeader from "./modalHeader";

/**
 * 汎用削除ポップアップ
 * @param props
 * @returns
 */
export default function DeleteModal<T>({
  title,
  name,
  target,
  onClose,
  onDelete,
}: {
  title: string;
  name: string;
  target: T;
  onClose: () => void;
  onDelete: (target: T) => void;
}) {
  return (
    <div className="modal">
      <div className="content">
        <ModalHeader title={title} onClose={onClose} />
        <div>
          <p>削除しますか？</p>
          <p>
            {`${title}名：`}
            {name}
          </p>
        </div>

        <div className="parts actions">
          <button onClick={onClose} className="negative">
            キャンセル
          </button>
          <button onClick={() => onDelete(target)} className="positive">
            削除
          </button>
        </div>
      </div>
    </div>
  );
}
